/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  ExportOrdersParams,
  GetOrdersParams,
  HTTPValidationError,
  OrderContentsCreate,
  OrderCreate,
  OrderRead,
  PageOrderManyRead,
  SendReceiptEmailParams,
} from "./fastAPI.schemas";

import { customInstance } from "../../axios";
import type { ErrorType } from "../../axios";

/**
 * Route to create a new order.
 * @summary Create Order
 */
export const createOrder = (orderCreate: OrderCreate, signal?: AbortSignal) => {
  return customInstance<string>({
    url: `/api/order/`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: orderCreate,
    signal,
  });
};

export const getCreateOrderMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createOrder>>,
    TError,
    { data: OrderCreate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createOrder>>,
  TError,
  { data: OrderCreate },
  TContext
> => {
  const mutationKey = ["createOrder"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createOrder>>,
    { data: OrderCreate }
  > = (props) => {
    const { data } = props ?? {};

    return createOrder(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateOrderMutationResult = NonNullable<
  Awaited<ReturnType<typeof createOrder>>
>;
export type CreateOrderMutationBody = OrderCreate;
export type CreateOrderMutationError = ErrorType<void | HTTPValidationError>;

/**
 * @summary Create Order
 */
export const useCreateOrder = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createOrder>>,
      TError,
      { data: OrderCreate },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createOrder>>,
  TError,
  { data: OrderCreate },
  TContext
> => {
  const mutationOptions = getCreateOrderMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Route to get many orders.

Results are paginated and filtered based on the current user's role.
 * @summary Get Orders
 */
export const getOrders = (params?: GetOrdersParams, signal?: AbortSignal) => {
  return customInstance<PageOrderManyRead>({
    url: `/api/order/`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetOrdersQueryKey = (params?: GetOrdersParams) => {
  return ["api", "order", ...(params ? [params] : [])] as const;
};

export const getGetOrdersQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrders>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetOrdersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrders>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrdersQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrders>>> = ({
    signal,
  }) => getOrders(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOrders>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrdersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrders>>
>;
export type GetOrdersQueryError = ErrorType<void | HTTPValidationError>;

export function useGetOrders<
  TData = Awaited<ReturnType<typeof getOrders>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params: undefined | GetOrdersParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrders>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrders>>,
          TError,
          Awaited<ReturnType<typeof getOrders>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOrders<
  TData = Awaited<ReturnType<typeof getOrders>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetOrdersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrders>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrders>>,
          TError,
          Awaited<ReturnType<typeof getOrders>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOrders<
  TData = Awaited<ReturnType<typeof getOrders>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetOrdersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrders>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Orders
 */

export function useGetOrders<
  TData = Awaited<ReturnType<typeof getOrders>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetOrdersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrders>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetOrdersQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Route to create many order_contents.

Note the separate order_contents crud file.
 * @summary Create Order Contents
 */
export const createOrderContents = (
  orderId: string,
  orderContentsCreate: OrderContentsCreate,
  signal?: AbortSignal,
) => {
  return customInstance<boolean>({
    url: `/api/order/${orderId}/contents`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: orderContentsCreate,
    signal,
  });
};

export const getCreateOrderContentsMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createOrderContents>>,
    TError,
    { orderId: string; data: OrderContentsCreate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createOrderContents>>,
  TError,
  { orderId: string; data: OrderContentsCreate },
  TContext
> => {
  const mutationKey = ["createOrderContents"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createOrderContents>>,
    { orderId: string; data: OrderContentsCreate }
  > = (props) => {
    const { orderId, data } = props ?? {};

    return createOrderContents(orderId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateOrderContentsMutationResult = NonNullable<
  Awaited<ReturnType<typeof createOrderContents>>
>;
export type CreateOrderContentsMutationBody = OrderContentsCreate;
export type CreateOrderContentsMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Create Order Contents
 */
export const useCreateOrderContents = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createOrderContents>>,
      TError,
      { orderId: string; data: OrderContentsCreate },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createOrderContents>>,
  TError,
  { orderId: string; data: OrderContentsCreate },
  TContext
> => {
  const mutationOptions = getCreateOrderContentsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Re-run bundle detection on an existing order without a full contents save.

Called after inline quantity edits on the review page.
 * @summary Recalculate Bundles
 */
export const recalculateBundles = (orderId: string, signal?: AbortSignal) => {
  return customInstance<string>({
    url: `/api/order/${orderId}/recalculate-bundles`,
    method: "POST",
    signal,
  });
};

export const getRecalculateBundlesMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof recalculateBundles>>,
    TError,
    { orderId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof recalculateBundles>>,
  TError,
  { orderId: string },
  TContext
> => {
  const mutationKey = ["recalculateBundles"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof recalculateBundles>>,
    { orderId: string }
  > = (props) => {
    const { orderId } = props ?? {};

    return recalculateBundles(orderId);
  };

  return { mutationFn, ...mutationOptions };
};

export type RecalculateBundlesMutationResult = NonNullable<
  Awaited<ReturnType<typeof recalculateBundles>>
>;

export type RecalculateBundlesMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Recalculate Bundles
 */
export const useRecalculateBundles = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof recalculateBundles>>,
      TError,
      { orderId: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof recalculateBundles>>,
  TError,
  { orderId: string },
  TContext
> => {
  const mutationOptions = getRecalculateBundlesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Create a new draft order cloned from an existing order.
 * @summary Duplicate Order
 */
export const duplicateOrder = (orderId: string, signal?: AbortSignal) => {
  return customInstance<string>({
    url: `/api/order/${orderId}/duplicate`,
    method: "POST",
    signal,
  });
};

export const getDuplicateOrderMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof duplicateOrder>>,
    TError,
    { orderId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof duplicateOrder>>,
  TError,
  { orderId: string },
  TContext
> => {
  const mutationKey = ["duplicateOrder"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof duplicateOrder>>,
    { orderId: string }
  > = (props) => {
    const { orderId } = props ?? {};

    return duplicateOrder(orderId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DuplicateOrderMutationResult = NonNullable<
  Awaited<ReturnType<typeof duplicateOrder>>
>;

export type DuplicateOrderMutationError = ErrorType<void | HTTPValidationError>;

/**
 * @summary Duplicate Order
 */
export const useDuplicateOrder = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof duplicateOrder>>,
      TError,
      { orderId: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof duplicateOrder>>,
  TError,
  { orderId: string },
  TContext
> => {
  const mutationOptions = getDuplicateOrderMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Export orders to CSV with true streaming.
 * @summary Export Orders
 */
export const exportOrders = (
  params?: ExportOrdersParams,
  signal?: AbortSignal,
) => {
  return customInstance<Blob>({
    url: `/api/order/export`,
    method: "GET",
    params,
    responseType: "blob",
    signal,
  });
};

export const getExportOrdersQueryKey = (params?: ExportOrdersParams) => {
  return ["api", "order", "export", ...(params ? [params] : [])] as const;
};

export const getExportOrdersQueryOptions = <
  TData = Awaited<ReturnType<typeof exportOrders>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: ExportOrdersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof exportOrders>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getExportOrdersQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof exportOrders>>> = ({
    signal,
  }) => exportOrders(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof exportOrders>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExportOrdersQueryResult = NonNullable<
  Awaited<ReturnType<typeof exportOrders>>
>;
export type ExportOrdersQueryError = ErrorType<void | HTTPValidationError>;

export function useExportOrders<
  TData = Awaited<ReturnType<typeof exportOrders>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params: undefined | ExportOrdersParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof exportOrders>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportOrders>>,
          TError,
          Awaited<ReturnType<typeof exportOrders>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExportOrders<
  TData = Awaited<ReturnType<typeof exportOrders>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: ExportOrdersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof exportOrders>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportOrders>>,
          TError,
          Awaited<ReturnType<typeof exportOrders>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExportOrders<
  TData = Awaited<ReturnType<typeof exportOrders>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: ExportOrdersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof exportOrders>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Export Orders
 */

export function useExportOrders<
  TData = Awaited<ReturnType<typeof exportOrders>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: ExportOrdersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof exportOrders>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getExportOrdersQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Route to get an order by ID.

Results are filtered based on the current user's role.
 * @summary Get Order
 */
export const getOrder = (orderId: string, signal?: AbortSignal) => {
  return customInstance<OrderRead>({
    url: `/api/order/${orderId}`,
    method: "GET",
    signal,
  });
};

export const getGetOrderQueryKey = (orderId?: string) => {
  return ["api", "order", orderId] as const;
};

export const getGetOrderQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrder>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  orderId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrder>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrderQueryKey(orderId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrder>>> = ({
    signal,
  }) => getOrder(orderId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!orderId,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getOrder>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetOrderQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrder>>
>;
export type GetOrderQueryError = ErrorType<void | HTTPValidationError>;

export function useGetOrder<
  TData = Awaited<ReturnType<typeof getOrder>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  orderId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrder>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrder>>,
          TError,
          Awaited<ReturnType<typeof getOrder>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOrder<
  TData = Awaited<ReturnType<typeof getOrder>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  orderId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrder>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrder>>,
          TError,
          Awaited<ReturnType<typeof getOrder>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOrder<
  TData = Awaited<ReturnType<typeof getOrder>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  orderId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrder>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Order
 */

export function useGetOrder<
  TData = Awaited<ReturnType<typeof getOrder>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  orderId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrder>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetOrderQueryOptions(orderId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Route to update an order by ID.
 * @summary Update Order
 */
export const updateOrder = (orderId: string, orderCreate: OrderCreate) => {
  return customInstance<string>({
    url: `/api/order/${orderId}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: orderCreate,
  });
};

export const getUpdateOrderMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateOrder>>,
    TError,
    { orderId: string; data: OrderCreate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateOrder>>,
  TError,
  { orderId: string; data: OrderCreate },
  TContext
> => {
  const mutationKey = ["updateOrder"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateOrder>>,
    { orderId: string; data: OrderCreate }
  > = (props) => {
    const { orderId, data } = props ?? {};

    return updateOrder(orderId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateOrderMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateOrder>>
>;
export type UpdateOrderMutationBody = OrderCreate;
export type UpdateOrderMutationError = ErrorType<void | HTTPValidationError>;

/**
 * @summary Update Order
 */
export const useUpdateOrder = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateOrder>>,
      TError,
      { orderId: string; data: OrderCreate },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateOrder>>,
  TError,
  { orderId: string; data: OrderCreate },
  TContext
> => {
  const mutationOptions = getUpdateOrderMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Route to delete an order by ID.
 * @summary Delete Order
 */
export const deleteOrder = (orderId: string) => {
  return customInstance<unknown>({
    url: `/api/order/${orderId}`,
    method: "DELETE",
  });
};

export const getDeleteOrderMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteOrder>>,
    TError,
    { orderId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteOrder>>,
  TError,
  { orderId: string },
  TContext
> => {
  const mutationKey = ["deleteOrder"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteOrder>>,
    { orderId: string }
  > = (props) => {
    const { orderId } = props ?? {};

    return deleteOrder(orderId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteOrderMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteOrder>>
>;

export type DeleteOrderMutationError = ErrorType<void | HTTPValidationError>;

/**
 * @summary Delete Order
 */
export const useDeleteOrder = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteOrder>>,
      TError,
      { orderId: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteOrder>>,
  TError,
  { orderId: string },
  TContext
> => {
  const mutationOptions = getDeleteOrderMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Route to get a PDF receipt for an order by ID.
 * @summary Get Order Receipt
 */
export const getOrderReceipt = (orderId: string, signal?: AbortSignal) => {
  return customInstance<Blob>({
    url: `/api/order/${orderId}/receipt`,
    method: "GET",
    responseType: "blob",
    signal,
  });
};

export const getGetOrderReceiptQueryKey = (orderId?: string) => {
  return ["api", "order", orderId, "receipt"] as const;
};

export const getGetOrderReceiptQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrderReceipt>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  orderId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrderReceipt>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetOrderReceiptQueryKey(orderId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrderReceipt>>> = ({
    signal,
  }) => getOrderReceipt(orderId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!orderId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getOrderReceipt>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrderReceiptQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrderReceipt>>
>;
export type GetOrderReceiptQueryError = ErrorType<void | HTTPValidationError>;

export function useGetOrderReceipt<
  TData = Awaited<ReturnType<typeof getOrderReceipt>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  orderId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrderReceipt>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrderReceipt>>,
          TError,
          Awaited<ReturnType<typeof getOrderReceipt>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOrderReceipt<
  TData = Awaited<ReturnType<typeof getOrderReceipt>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  orderId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrderReceipt>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrderReceipt>>,
          TError,
          Awaited<ReturnType<typeof getOrderReceipt>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOrderReceipt<
  TData = Awaited<ReturnType<typeof getOrderReceipt>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  orderId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrderReceipt>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Order Receipt
 */

export function useGetOrderReceipt<
  TData = Awaited<ReturnType<typeof getOrderReceipt>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  orderId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrderReceipt>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetOrderReceiptQueryOptions(orderId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Route to send a receipt email to the patient for a given order.
 * @summary Send Receipt Email
 */
export const sendReceiptEmail = (
  orderId: string,
  params: SendReceiptEmailParams,
  signal?: AbortSignal,
) => {
  return customInstance<boolean>({
    url: `/api/order/${orderId}/send_receipt_email`,
    method: "POST",
    params,
    signal,
  });
};

export const getSendReceiptEmailMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendReceiptEmail>>,
    TError,
    { orderId: string; params: SendReceiptEmailParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendReceiptEmail>>,
  TError,
  { orderId: string; params: SendReceiptEmailParams },
  TContext
> => {
  const mutationKey = ["sendReceiptEmail"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendReceiptEmail>>,
    { orderId: string; params: SendReceiptEmailParams }
  > = (props) => {
    const { orderId, params } = props ?? {};

    return sendReceiptEmail(orderId, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendReceiptEmailMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendReceiptEmail>>
>;

export type SendReceiptEmailMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Send Receipt Email
 */
export const useSendReceiptEmail = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof sendReceiptEmail>>,
      TError,
      { orderId: string; params: SendReceiptEmailParams },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof sendReceiptEmail>>,
  TError,
  { orderId: string; params: SendReceiptEmailParams },
  TContext
> => {
  const mutationOptions = getSendReceiptEmailMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
